module.exports = __webpack_public_path__ + "img/desc_title.602dde1f.svg";